import React from 'react';
import { Group, Modal, Button, Text, Stack } from '@mantine/core';

export interface DeleteDialogProps {
  open: boolean;
  onClose(): void;
  onConfirm(): void;
  onCancel(): void;
  title: string;
  message: string;
  acceptText: string;
  declineText: string;
}

export interface WithDeleteDialogSupport {
  openDeleteDialog(path: string, data: number): void;
}

export const DeleteDialog = React.memo(function DeleteDialog({
  open,
  onClose,
  onConfirm,
  onCancel,
  title,
  message,
  acceptText,
  declineText,
}: DeleteDialogProps) {
  return (
    <Modal opened={open} onClose={onClose} title={title}>
      <Stack>
        <Text>{message}</Text>
        <Group justify='flex-end' gap='xs'>
          <Button onClick={onCancel}>{declineText}</Button>
          <Button onClick={onConfirm}>{acceptText}</Button>
        </Group>
      </Stack>
    </Modal>
  );
});
